module.exports = __webpack_public_path__ + "img/corporacionmedica-alt.93462980.png";